var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container"},[_c('div',{staticClass:"content"},[_c('i',{staticClass:"el-icon-success icon"}),_c('p',[_vm._v(" "+_vm._s('A new page is displayed. The page is invalid. Do not repeat the operation')+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }